import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { RiArrowUpSLine } from "react-icons/ri";
import FloatingSupport from "../chatbot/floting";
// import { useTheme } from "../togglethemebar/ThemeContext";
import EBrochureModal from "../components/ebrochure/E-brochure";
export const Footer = ({ handleApprovalClick }) => {
  // const { theme } = useTheme();
  const [isVisible, setIsVisible] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const timeoutRef = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  // Initialize AOS animation
  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  // Function to handle hovering
  // const handleMouseEnter = () => {
  //   setIsHovered(true);
  // };
  // const handleMouseLeave = () => {
  //   setIsHovered(false);
  // };

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop1 = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleMouseEnter = () => {
    clearTimeout(timeoutRef.current); // Cancel any timeout
    setShowMenu(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setShowMenu(false);
    }, 1000); // Keep the menu active for 2 seconds after mouse leaves
  };

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current); // Cleanup on component unmount
  }, []);
  return (
    <>
      {/* <div className={theme === "dark" ? "footer-dark" : "footer-light"}> */}
      {/* <!--Start Footer Area--> */}
      <div className="footer-area pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-sm-6">
              <div className="footer-logo-area">
                <Link to="/">
                  <img
                    src="assets/images/logo-light.svg"
                    title="Footer Logo"
                    alt="footerlogo"
                    width={270}
                    height={84}
                  />
                </Link>
                <p>
                  McGAN'S Ooty School of Architecture Perar, Kotagiri Road,
                  Ooty, The Nilgiris, Tamilnadu - 643 002 .
                </p>
                <div className="contact-list">
                  <ul>
                    <li>
                      <a href="mailto: mcgansoffice@gmail.com">
                        Email: mcgansoffice@gmail.com
                      </a><br />
                      <a href="ootyarchitecture@gmail.com">
                        ootyarchitecture@gmail.com
                      </a>
                    </li>
                    <li>
                      <a href="tel:+93445 11168">
                        For Admission - +91 93445 11168,+91 94883 36599
                      </a>
                    </li>
                    <li>
                      <a href="tel:04232225970">0423 - 2225970 .</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="footer-widjet">
                <h3>Quick Links</h3>
                <div className="list">
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/about-us">About</Link>
                    </li>
                    <li>
                      <Link to="/gallery">Gallery</Link>
                    </li>
                    <li>
                      <Link to="/campus">
                        Campus
                      </Link>
                    </li>
                    <li>
                      <Link to="/placement">Placement</Link>
                    </li>
                    <li>
                      <Link to="/staff">Faculty & Staff</Link>
                    </li>
                    <li>
                      <Link to="/alumni">Alumni</Link>
                    </li>
                    <li>
                      <Link to="/achievements">Achievements</Link>
                    </li>


                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="footer-widjet">
                <h3>Our Campus</h3>
                <div className="list">
                  <ul>
                    <li>
                      <Link to="/campus-playgrounddetails">Playground</Link>
                    </li>
                    {/* <li>
                      <Link to="/campus-fitnessdetails">Fitness Center</Link>
                    </li> */}
                    <li>
                      <Link to="/campus-messdetails">Mess</Link>
                    </li>
                    <li>
                      <Link to="/campus-studiodetails">Studio</Link>
                    </li>
                    <li>
                      <Link to="/campus-librarydetails">Library</Link>
                    </li>
                    <li>
                      <Link to="/campus-hosteldetails">Hostel</Link>
                    </li>
                  </ul>


                  {/* <iframe
  style={{
    border: 0,
    width: "125px",
    height: "100px",
    marginTop: "-24px",
  }}
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3910.8681261624297!2d76.76506041475486!3d11.417116491888672!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba8be3a914e4353%3A0x2dedb528b948c1e6!2sMcGan's%20Ooty%20School%20of%20Architecture!5e0!3m2!1sen!2sin!4v1577037601094!5m2!1sen!2sin"
  allowFullScreen
  loading="lazy"
  title="GoogleMap"
></iframe> */}

                </div>
              </div>
              <div className="footer-widjet">
                <h3>E-Brochure</h3>
                <div className="list">
                  <ul>
                    <li>
                      <button type="button" className="nav-link" style={{ color: "#ffffff", cursor: 'pointer' }} onClick={() => setOpenModal(true)} aria-label="Open E-Brochure 2026">
                        E-Brochure-2026
                      </button>
                    </li>
                  </ul></div></div>
            </div>

            <div className="col-lg-2 col-sm-6">
              <div className="footer-widjet">
                <h3>Academics</h3>
                <div className="list">
                  <ul>
                    <li>
                      <Link to="/undergraduate">Undergraduate</Link>
                    </li>
                    <li>
                      <Link to="/postgraduate">Postgraduate</Link>
                    </li>
                    {/* <li>
                      <Link to="/diploma">Diploma</Link>
                    </li> */}
                    <li>
                      <Link to="/international-student">
                        International Student
                      </Link>
                    </li>
                  </ul>

                </div>
                <br></br>
                <div className="footer-widjet">
                  <div className="list">
                    <h3>Other Links</h3>
                    <ul>
                      <li>
                        <button
                          type="button"
                          onClick={() => handleApprovalClick()}
                          className="nav-link"
                          style={{ color: '#ffffff', cursor: 'pointer' }}
                          aria-label="View COA approval 2025"
                        >
                          COA Approval - 2025
                        </button>
                      </li>
                      <li>
                        <a
                          href="https://api.mcgansarch.com/uploads/news-letters/news_letter_1.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nav-link"
                          style={{ color: '#ffffff', cursor: 'pointer' }}
                        >
                          News Letter 1 - 2025
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://api.mcgansarch.com/uploads/news-letters/news_letter_2.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nav-link"
                          style={{ color: '#ffffff', cursor: 'pointer' }}
                        >
                          News Letter 2 - 2025
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://api.mcgansarch.com/uploads/news-letters/news_letter_3.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nav-link"
                          style={{ color: '#ffffff', cursor: 'pointer' }}
                        >
                          News Letter 3 - 2025
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://api.mcgansarch.com/uploads/news-letters/news_letter_4.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nav-link"
                          style={{ color: '#ffffff', cursor: 'pointer' }}
                        >
                          News Letter 4 - 2025
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://api.mcgansarch.com/uploads/news-letters/news_letter_5.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nav-link"
                          style={{ color: '#ffffff', cursor: 'pointer' }}
                        >
                          News Letter 5 - 2026
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div className="shape">
            <img
              src={("../assets/images/shape-1.png")}
              width={829}
              height={351}
              title="Shape"
              alt="Shape"
            />
          </div>
        </div>
      </div>
      {/* <!--End Footer Area--> */}

      {/* <!--Start Copyright Area--> */}
      <div className="copyright-area">
        <div className="container">
          <div className="copyright">
            <div className="row">
              <div className="col-lg-4 col-md-4">
                <div className="social-content">
                  <ul>
                    <li>
                      <span>Follow Us On</span>
                    </li>
                    <li>
                      <a
                        href="https://linkedin.com/company/mcgansarch"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="McGAN'S on LinkedIn (opens in new tab)"
                      >
                        <i className="ri-linkedin-fill" aria-hidden="true"></i>
                        <span className="visually-hidden">LinkedIn</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://x.com/mcgansarch"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="McGAN'S on X (opens in new tab)"
                      >
                        <i className="ri-twitter-fill" aria-hidden="true"></i>
                        <span className="visually-hidden">X (Twitter)</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.youtube.com/@mcgansooty3246"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="McGAN'S on YouTube (opens in new tab)"
                      >
                        <i className="ri-youtube-fill" aria-hidden="true"></i>
                        <span className="visually-hidden">YouTube</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.instagram.com/mcgansarch/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="McGAN'S on Instagram (opens in new tab)"
                      >
                        <i className="ri-instagram-line" aria-hidden="true"></i>
                        <span className="visually-hidden">Instagram</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.facebook.com/McGansArch"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="McGAN'S on Facebook (opens in new tab)"
                      >
                        <i className="ri-facebook-fill" aria-hidden="true"></i>
                        <span className="visually-hidden">Facebook</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-8 col-md-8">
                <div className="copy">
                  <p>
                    © Copyright {new Date().getFullYear()} by McGAN'S Ooty
                    School of Architecture. Handcrafted with ♥ by{" "}
                    <a
                      href="https://www.dotwings.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="ListItem"
                      aria-label="Dotwings (opens in new tab)"
                    >
                      <b>Dotwings</b>.
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!--End Copyright Area--> */}

      {/* Apply Now */}
      <div
        className={`go-top ${isVisible ? "active" : ""}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="button-container">
          <button
            type="button"
            className="default-btn btn admission colourstyle"
          >
            Apply Now
          </button>
        </div>

        {/* Popup Modal */}
        {showMenu && (
          <div className="modal-overlay">
            <div className="modal-contents buttonApply">
              <div className="modal-button-row">
                {/* <button
                  className="modal-button"
                  onClick={() => navigate("/diploma-application")}
                >
                  Diploma
                </button> */}
                <button
                  className="modal-button"
                  onClick={() => navigate("/barch-application")}
                >
                  B.Arch
                </button>
                <button
                  className="modal-button"
                  onClick={() => navigate("/march-application")}
                >
                  M.Arch
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Scroll Up Icon */}
        {isVisible && <RiArrowUpSLine onClick={scrollToTop1} />}
      </div>
      <FloatingSupport />

      <EBrochureModal open={openModal} onClose={() => setOpenModal(false)} />


      {/* End */}
      {/* <!-- Start Go Top Area --> */}
      <div
        className={`go-top ${isVisible ? "active" : ""} additional-class`}
        onClick={scrollToTop}
      >
        {/* <i className="ri-arrow-up-s-line"></i> */}

        {/* <RiArrowUpSLine /> */}
      </div>
      {/* <!-- End Go Top Area --> */}
      {/* </div> */}
    </>
  );
};
